import React from 'react'
import { TStepProps } from '@health-zelas/quiz'
import { TextInput, RequiredField } from '@packages/components'

import { QuestionHeader } from '../../../components/QuestionHeader'

import { BaseLayout } from '../../../layouts/BaseLayout'

import { numberMask } from '../../../utils/masks'

export function Dependents({ ProgressBar, Navigation }: TStepProps){
  return (
    <BaseLayout navigation={Navigation} progressBar={ProgressBar}>
      <QuestionHeader
        title="Quantos dependentes gostaria de incluir?"
      />

      <TextInput
        label="Digite o número de dependentes"
        name="n__total_de_pessoas"
        id="n__total_de_pessoas"
        mask={numberMask}
        required
        validator={RequiredField}
      />
    </BaseLayout>
  )
}
